import {Component, Input, Inject, Output, EventEmitter} from '@angular/core';
import {NoizuStruct} from '../../../noizu/structs/noizu-struct';
import {ModalWidgetEnum, WidgetEnum} from '../../../enums/widget';
import {ModalWidget} from "../../../entities/";
import {ToasterService} from 'angular2-toaster';
import {ModalWidgetEventStruct} from './modal-widget-event.struct';

@Component({
  selector: 'mini-modal-widget',
  template: `
    <div class="modal-body">
      <widget-spinner *ngIf="entity?.processing"></widget-spinner>
      <div  *ngIf="!entity?.processing">
        <widget [entity]="entity?.subject" [layout]="entity?.embed_layout" [options]="entity?.embed_options"></widget>
      </div>
    </div>
  `
})
export class MiniModalWidgetComponent {
  @Input() entity: ModalWidget | null = null;
  @Input() templateHint: string = null;
  @Input() options: any = null;
  @Input() layout = 'standard';
  @Output() widgetEvent = new EventEmitter<ModalWidgetEventStruct>();
  forwardEvent(e, widgetEvent: ModalWidgetEventStruct) {
    e.preventDefault();
    this.widgetEvent.emit(widgetEvent);
  }
  constructor(public toasterService: ToasterService) {

  }
}
